import React from 'react';

export default function WaitlistPage() {
  return (
    <div className="auth-shell">
      <div className="auth-card text-center">
        <div className="auth-brand justify-center">
          <span className="brand-icon">C</span>
          <div>
            <h1>CrypnAI</h1>
            <p>Beta access</p>
          </div>
        </div>

        <h2>You’re on the waitlist</h2>
        <p className="auth-meta">
          Thanks for signing up. We'll email you when your beta access is approved.
        </p>

        <div className="success-box">
          <p>We send invites in batches, so keep an eye on your inbox.</p>
        </div>

        <a href="/login" className="btn-secondary w-full inline-flex justify-center">
          Back to login
        </a>
      </div>
    </div>
  );
}
